import Home from '../views/Home.vue'
import Layout from '../views/Layout.vue'
import LogIn from '../views/LogIn.vue'
import TESTAPI from '../views/TESTAPI.vue'

export const sharedRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/LogIn'
  },
  {
    path: '/LogIn',
    name: 'LogIn',
    component: LogIn,
    meta: { requiresAuth: false }
  },
  {
    path: '/TESTAPI',
    name: 'TESTAPI',
    component: TESTAPI,
    meta: { requiresAuth: true }
  },
  {
    path: '/Layout',
    name: 'Layout',
    component: Layout,
    meta: { requiresAuth: true }
  }
]
